export default __webpack_public_path__ + "static/media/fastify.1b930a41.svg";